var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 bg-light shadow",attrs:{"id":"received-files-sidebar"}},[_c('div',{staticClass:"d-flex flex-column"},_vm._l((_vm.sections),function(section){return _c('received-files-sidebar-section',{key:section.id,attrs:{"section":section}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddd7ace","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/received-files-view/received-files-sidebar.vue
// module id = 102
// module chunks = 0